import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as VirtualConnectionTableDownstreamOwnerIdsQuery
export const VirtualConnectionTableDownstreamOwnersQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamOwnersQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: TableauUserSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
